<ng-template #sideOverContent>
  <div class="e11-h-full e11-divide-y e11-divide-gray-200 e11-flex e11-flex-col e11-bg-white e11-shadow-xl">
    <div class="e11-flex-1 e11-h-0 e11-overflow-y-auto e11-overscroll-none">
      <div *ngIf="showHeader" class="e11-py-6 e11-px-4 e11-bg-skin-primary sm:e11-px-6">
        <div class="e11-flex e11-items-center e11-justify-between e11-mb-2">
          <h2 class="e11-text-lg e11-font-medium e11-text-white e11-mb-0" id="slide-over-title">
            {{ headerTitle | translate }}
          </h2>
          <div class="e11-ml-3 e11-h-7 e11-flex e11-items-center">
            <button
              (click)="close()"
              type="button"
              class="e11-flex e11-items-center e11-justify-center e11-bg-skin-primary e11-h-6 e11-w-6 e11-rounded-md e11-text-white/70 hover:e11-text-white focus:e11-outline-none focus:e11-ring-1 focus:e11-ring-white hover:e11-ring-1 hover:e11-ring-white"
              [ngClass]="{ 'e11-cursor-wait': loading }"
            >
              <span class="e11-sr-only">Close panel</span>
              <span class="material-icons-outlined md-18"> close </span>
            </button>
          </div>
        </div>
        <div class="">
          <p class="e11-text-sm e11-text-white/70">
            {{ subTitle | translate }}
          </p>
        </div>
      </div>

      <ng-container *ngIf="isOpen">
        <ng-content></ng-content>
      </ng-container>
    </div>

    <div *ngIf="showFooter" class="e11-flex e11-justify-end e11-p-4 e11-flex-shrink-0">
      <e11-button
        *ngIf="showCloseButton"
        [value]="'Close' | translate"
        color="neutral"
        [icon]="'close'"
        [iconPosition]="'left'"
        [iconSize]="'md-18'"
        (click)="close()"
        [buttonGroup]="true"
      >
      </e11-button>
      <e11-button
        *ngIf="showDeleteButton"
        color="secondary"
        [type]="'button'"
        value="{{ 'Delete' | translate }}"
        icon="delete"
        iconPosition="left"
        [buttonGroup]="true"
        (click)="removeItem.emit()"
        [icon]="'delete'"
        [iconPosition]="'left'"
        [iconSize]="'md-18'"
      >
      </e11-button>

      <e11-button
        *ngIf="showSubmitButton"
        (click)="submitItem.emit()"
        value="{{ 'Save' | translate }}"
        color="primary-accent"
        [buttonGroup]="true"
        [disabled]="submitDisabled"
        [icon]="'save'"
        [iconPosition]="'left'"
        [iconSize]="'md-18'"
      >
      </e11-button>
    </div>
  </div>
</ng-template>
